
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BasePageContainer from '@/components/reports-v3/pages/BasePageContainer.vue';
import moment from 'moment';
import AgentsListFilter from '@/components/reports-v3/components/filters/AgentsListFilter.vue';
import CustomerListFilter from '@/components/reports-v3/components/filters/CustomerListFilter.vue';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import LastSync from '@/components/LastSync.vue';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import gdbx from '@/store/modules/gdbx';
// tslint:disable-next-line:max-line-length
import TotalOutstandingNumberDisplayer from '../../components/codedWidgets/customer/CustomerTotalOutstandingNumberDisplayer.vue';
import TotalDueNumberDisplayer from '../../components/codedWidgets/customer/CustomerTotalDueNumberDisplayer.vue';
import TotalOverdueNumberDisplayer from '../../components/codedWidgets/customer/CustomerOverdueNumberDisplayer.vue';
import CustomerOutstandingTreeMap from '../../components/codedWidgets/customer/CustomerOutstandingTreeMap.vue';
import CustomerOverdueTreeMap from '../../components/codedWidgets/customer/CustomerOverdueTreeMap.vue';
import CustomerUpcomingDueTable from '../../components/codedWidgets/customer/CustomerOverdueTable.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import UnappliedAmountPieChart from '../../components/codedWidgets/customer/CustomerUnAppliedAmountPieChart.vue';
import CustomerAgingSummaryBarChart from '../../components/codedWidgets/customer/CustomerAgingSummaryBarChart.vue';
import CustomerAgingOverviewTable from '../../components/codedWidgets/customer/CustomerAgingOverviewTable.vue';
import CustomerDueAgingTable from '../../components/codedWidgets/customer/CustomerDueAgingTable.vue';

@Component({
  components: {
    AgentsListFilter,
    CustomerListFilter,
    DateFilter,
    StickyFilterContainer,
    LastSync,
    TotalOutstandingNumberDisplayer,
    TotalDueNumberDisplayer,
    TotalOverdueNumberDisplayer,
    CustomerOutstandingTreeMap,
    CustomerUpcomingDueTable,
    UnappliedAmountPieChart,
    CustomerAgingSummaryBarChart,
    CustomerAgingOverviewTable,
    CustomerOverdueTreeMap,
    CustomerDueAgingTable,
  },
})
export default class Customer extends BasePageContainer {
  public selectedAgents: string[] = [];
  public selectedCustomers: string[] = [];
  public selectedAsOfDate: number = moment().endOf('day').valueOf();
  public selectedDateRange: [number, number] = [
    moment().startOf('year').valueOf(),
    moment().endOf('day').valueOf(),
  ];

  public mounted() {
  }
}
